import React from 'react';

const TimeSlot = ({ timeSlot, reservation, onTimeSlotClick, onDeleteReservation }) => {
  const handleClick = () => {
    if (!reservation) {
      onTimeSlotClick(timeSlot);
    }
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    onDeleteReservation(timeSlot);
  };

  return (
    <div
      className={`group relative p-4 rounded-2xl border-2 cursor-pointer transition-all duration-300 transform hover:scale-105 min-h-[120px] flex flex-col ${
        reservation
          ? 'bg-gradient-to-br from-red-100 via-orange-50 to-red-100 border-red-300 shadow-lg hover:shadow-xl ring-2 ring-red-200'
          : 'bg-white border-gray-200 hover:border-purple-300 hover:bg-gradient-to-br hover:from-purple-50 hover:to-blue-50 shadow-sm hover:shadow-md'
      }`}
      onClick={handleClick}
    >
      {/* Delete Button for Reservations - Moved to top for better positioning */}
      {reservation && (
        <button
          onClick={handleDelete}
          className="absolute top-2 right-2 p-1 text-white bg-red-500 hover:bg-red-600 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg z-10"
          title="Fshi rezervimin"
        >
          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
        </button>
      )}

      {/* Time Display with proper spacing */}
      <div className={`text-center mb-3 ${reservation ? 'pr-8' : ''}`}>
        <div className={`text-lg font-bold flex items-center justify-center space-x-1 ${
          reservation ? 'text-red-800' : 'text-gray-800'
        }`}>
          <span className="text-sm">{reservation ? '🔒' : '🕐'}</span>
          <span>{timeSlot}</span>
        </div>
      </div>

      {/* Content Area */}
      <div className="flex-1 flex flex-col justify-center">
        {reservation ? (
          <div className="text-center">
            <div className="text-red-600 mb-2 text-xl">👤</div>
            <div className="text-xs text-red-800 font-bold leading-tight mb-3 line-clamp-2 bg-white/60 rounded-lg px-2 py-1">
              {reservation.clientName}
            </div>
            <div className="inline-flex items-center px-3 py-1.5 rounded-full text-xs font-bold bg-red-500 text-white shadow-md">
              🚫 ZËNË
            </div>
          </div>
        ) : (
          <div className="text-center">
            <div className="text-green-500 mb-1 text-lg">✨</div>
            <div className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700 group-hover:bg-green-200 transition-colors">
              E Lirë
            </div>
          </div>
        )}
      </div>

      {/* Subtle background pattern for available slots */}
      {!reservation && (
        <div className="absolute inset-0 opacity-0 group-hover:opacity-5 bg-gradient-to-br from-purple-400 to-blue-400 rounded-2xl transition-opacity duration-300"></div>
      )}

      {/* Busy slot overlay pattern */}
      {reservation && (
        <div className="absolute inset-0 opacity-10 bg-gradient-to-br from-red-400 to-orange-400 rounded-2xl"></div>
      )}
    </div>
  );
};

export default TimeSlot; 